/** @format */
import { Injectable } from '@angular/core';
import { UIRouterGlobals } from '@uirouter/core';

export interface WithStaffOrTeacherRole {
    get role(): string;
}
export const ROUTE_ROLES = {
    teacher: 'teacher',
    staff: 'staff',
} as const;
@Injectable({
    providedIn: 'root',
})
export class RouteRoleService {
    constructor(private uiRouterGlobals: UIRouterGlobals) {}

    isTeacherRoute() {
        return this.uiRouterGlobals.params.role === ROUTE_ROLES.teacher;
    }

    getRole(): keyof typeof ROUTE_ROLES {
        return this.isTeacherRoute() ? ROUTE_ROLES.teacher : ROUTE_ROLES.staff;
    }
}
